import axios from 'axios';
import { useAppState } from '../redux';
import { useMutation } from 'react-query';
import { PromoteMode } from '../../components/GlobalJobMatching/GlobalJobMatchingVersioning/types/versions';
import { notifications } from '@mantine/notifications';

export const useApplyRules = () => {
  const { session: { masterAccountId, csrf_token, csrf_timestamp } } = useAppState()

  const applyRulesToJobs = async ({ id, mode }: { id?: string | number, mode: PromoteMode }): Promise<any> => {
    if (!id) return
    const response = await axios.post(`/cms/api/accounts/${masterAccountId}/global-job-pricing/versions/${id}/promote`, { mode, csrf_token, csrf_timestamp });

    return response
  }

  const mutation = useMutation(applyRulesToJobs, {
    onSuccess: () => {
      notifications.show({ title: 'Success', message: 'Pricing rules successfully applied to jobs.'})
    },
    onError: () => {
      notifications.show({ title: 'Error', message: 'Unable to apply rules to jobs.', color: 'red' })
    }
  })

  return mutation
}
